import React, { memo } from 'react';
import PropTypes from 'prop-types';
import SwitchItem from './item';
import cx from 'classnames'

const MultiplySwitch = ({
   label,
   onClick,
   items,
   children,
   height,
   newstyle,
   screenWidth,
   labelClassName,
}) => {
   const dataIsArray = Array.isArray(items) && items.length > 0 && !(!!children);
   return (
      <div className={ `flex flex-col select-none ${ newstyle && screenWidth > 1022 ? '' : '' }` }>
         {
            label && (
               <div className='mb-2'>
                  <span className={ cx({
                     'font-bold text-major dark:text-major-dark switch-label leading-tight': true,
                     [labelClassName]: labelClassName,
                  }) }>{ label }</span>
               </div>
            )
         }
         <div className={ `h-${ height } flex rounded-lg overflow-hidden ${ newstyle ? 'p-[6px] bg-[#FCFCFD] gap-2 border border-divider' : '' }` }>
            { dataIsArray && items.map((item, index) => (
               <SwitchItem
                  key={ index.toString() }
                  label={ item.label }
                  checked={ item.checked }
                  onClick={ () => onClick(item) }
                  icon={ item.icon }
                  isLoading={ !item.checked }
               />
            )) }
            { !!children && children }
         </div>
      </div>
   );
};

MultiplySwitch.propTypes = {
   label: PropTypes.string,
   items: PropTypes.array,
   onClick: PropTypes.func.isRequired,
   children: PropTypes.any,
   height: PropTypes.any,
   newstyle: PropTypes.bool,
   screenWidth: PropTypes.any,
   labelClassName: PropTypes.string,
};
MultiplySwitch.defaultProps = {
   height: 18,
   newstyle: false,
   screenWidth: '',
   labelClassName: '',
};

export default memo(MultiplySwitch);
export {
   SwitchItem,
};
